import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, Switch, useParams, useRouteMatch } from 'react-router-dom'
import ModularConferenceForm from './ModularConferenceForm'

const ActiveConferenceGuard = () => {
  const { path } = useRouteMatch()
  const { conferenceId } = useParams()
  const user = useSelector((state) => state.auth.user)

  if (conferenceId !== user.conferenceId) {
    return <Redirect to={`${path}/${user.conferenceId}`} />
  }

  return <ModularConferenceForm />
}

const MyConference = () => {
  const { path } = useRouteMatch()
  const user = useSelector((state) => state.auth.user)

  return (
    <>
      <Switch>
        <Route exact path={`${path}/:conferenceId`}>
          <ActiveConferenceGuard />
        </Route>
        <Redirect to={`${path}/${user.conferenceId}`} />
      </Switch>
    </>
  )
}

export default MyConference
